import { Outlet } from 'react-router-dom'

import { ReactComponent as Logo } from '../../../assets/svgs/logo.svg'
import { SelectLanguage } from '../../../components/SelectedLanguage'
import { ProfileMenu } from '../../../components/ProfileMenu'
import { SkillsMobileMenu } from '../../../components/SkillsMobileMenu'
import { ExpertMobileNavigation } from '../../../components/ExpertMobileNavigation'
import { ExpertDesktopNavigation } from '../../../components/ExpertDesktopNavigation'
import { BurguerMenuButton } from '../../../components/BurguerMenuButton'
import { useToggle } from '../../../hooks/useToggle'

export const Root = () => {
  const [mobileMenuIsOpen, , setMobileMenuIsOpen] = useToggle()
  const [skillsMenuIsOpen, , setSkillsMenuIsOpen] = useToggle()

  return (
    <>
      <header className="flex items-center px-6 h-24 lg:border-b-2 lg:border-grey-300">
        <Logo className="w-24 mr-28" />

        <div className="hidden lg:grow lg:flex lg:items-center">
          <ExpertDesktopNavigation />

          <div className="flex items-center gap-8 ml-auto">
            <ProfileMenu />
            <SelectLanguage />
          </div>
        </div>

        <nav className="ml-auto lg:hidden">
          <section>
            <BurguerMenuButton onOpenMenu={() => setMobileMenuIsOpen(true)} />

            <ExpertMobileNavigation
              isOpen={mobileMenuIsOpen}
              onClose={() => setMobileMenuIsOpen(false)}
              onOpenSkillsMenu={() => setSkillsMenuIsOpen(true)}
            />

            <SkillsMobileMenu
              isOpen={skillsMenuIsOpen}
              onClose={() => setSkillsMenuIsOpen(false)}
            />
          </section>
        </nav>
      </header>

      <main className="flex flex-col px-6 py-10 grow">
        <Outlet />
      </main>
    </>
  )
}
